import ar from './ar.json';
import en from './en.json';

export * from './permissions.util';

/**
 * Translated names for the code-declared permission catalogue.
 *
 * `PermissionDefinition` deliberately carries no label — labels are translated
 * content (U8/N5's reasoning applied to a code catalogue), so they live here.
 * The colocated spec asserts every catalogue key is covered in both locales, so
 * a permission added by a later phase cannot reach a staff-facing checklist as a
 * raw key.
 */
export const permissionCatalogs = { ar, en };
